document.addEventListener("DOMContentLoaded", function () {
  const shippingFeeVariantId = 42024182120557; // Flat Shipping Fee Variant ID
  const bogoItemWeight = 136; //BOGO item weight

  function updateCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        let bogosleepCount = 0; // Count BOGO items in cart
        let shippingFeePresent = false; // Check if Flat Shipping Fee is in the cart

        // Iterate through cart items
        cart.items.forEach((item) => {
          if (item.grams === bogoItemWeight) {
            bogosleepCount += item.quantity; // Count BOGO items
          }
          if (item.variant_id === shippingFeeVariantId) {
            shippingFeePresent = true; // Check if Flat Shipping Fee is in cart
          }
        });

        console.log("BOGO item count:", bogosleepCount);
        console.log("Flat Shipping Fee present:", shippingFeePresent);

        // Add Flat Shipping Fee if there are 2 or more BOGO items and it's not already in the cart
        if (bogosleepCount > 1 && !shippingFeePresent) {
          console.log("Adding Flat Shipping Fee...");
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: shippingFeeVariantId, quantity: 1 }),
          }).then(() => {
            console.log("Flat Shipping Fee added to cart.");
            location.reload(); // Refresh cart to reflect changes
          });
        }

        // Remove Flat Shipping Fee if there are no BOGO items or only 1 BOGO item
        if (bogosleepCount <= 1 && shippingFeePresent) {
          console.log("Removing Flat Shipping Fee...");
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              line:
                cart.items.findIndex(
                  (item) => item.variant_id === shippingFeeVariantId
                ) + 1,
              quantity: 0,
            }),
          }).then(() => {
            console.log("Flat Shipping Fee removed from cart.");
            location.reload(); // Refresh cart to reflect changes
          });
        }
      })
      .catch((error) => console.error("Error fetching cart data:", error));
  }

  // Event listener for clicks on remove buttons
  document.body.addEventListener("click", function (event) {
    if (
      event.target.matches(".remove") || // Remove button
      event.target.closest(".remove") // Parent of remove button
    ) {
      console.log("Remove button clicked, checking cart...");
      setTimeout(updateCart, 500); // Delay to allow cart update
    }
  });

  // Event listener for quantity adjustments
  document.body.addEventListener("input", function (event) {
    if (event.target.matches(".update-cart--template")) {
      console.log("Quantity adjusted, checking cart...");
      setTimeout(updateCart, 500); // Delay to allow cart update
    }
  });

  // Event listener for cart item changes (optional, for instant updates)
  document.body.addEventListener("click", function (event) {
    if (event.target.matches(".remove, .update-cart--template")) {
      updateCart(); // Direct call to update cart on click
    }
  });

  // Initial check on page load
  updateCart();
});
